module.exports = __webpack_public_path__ + "media/images/icon_people-cb4e3abd01ca2ff76eab27ffaf780a8c.png";